
import { ICefSharp } from "./Interfaces/_ICefSharp";
import { IConfigRepository } from "../../../interfaces/IConfigRepository";
import { AppConfigurationData } from "../../../models/AppConfigurationData";
import { ICefSharpAppConfigurationService } from "./Interfaces/ICefSharpAppConfigurationService";
import AuthService from "Infrastructure/repositories/auth/AuthService";
import { AcquirerType } from "Infrastructure/repositories/auth/IAuthService";
import { getDeviceInfo } from "modules/reactNativeBridge/ReactNativeBridge";

declare const CefSharp: ICefSharp;
declare const appConfigurationService: ICefSharpAppConfigurationService;

export const CefSharpConfigRepository = (): IConfigRepository => {

  const getConfigAsync = async (): Promise<AppConfigurationData> => {

    if(typeof CefSharp === 'undefined') {
    
      const authService = AuthService();


      const deviceInfo = await getDeviceInfo();

      if(deviceInfo) {
        const authResponse = await authService.authenticate(deviceInfo.serialNumber, deviceInfo.serialNumber, AcquirerType.PAGSEGURO);

      return {
        printType: 0,
        ticketNote: "", 
        tickectName: "",
        printQRCodeTicket: false,
        cnpj: "",
        userAgent: "",
        urlApp: "",
        equipamentId: authResponse.id,
        token: authResponse.token,
        macAddress: deviceInfo.serialNumber,
      }
      } else {
        throw new Error("Device info not found");
     }
    }

    await CefSharp.BindObjectAsync("appConfigurationService");
    const appConfigData = await appConfigurationService.get();
    console.log("appConfigData: ", appConfigData);

    return {
      printType: appConfigData.PrintType,
      ticketNote: appConfigData.TicketNote,
      tickectName: appConfigData.TickectName,
      printQRCodeTicket: appConfigData.PrintQRCodeTicket,
      cnpj: appConfigData.CNPJ,
      userAgent: appConfigData.UserAgent,
      urlApp: appConfigData.UrlApp,
      equipamentId: appConfigData.EquipamentId,
      token: appConfigData.Token,
      macAddress: appConfigData.MacAddress,
    };
  };

  return { getConfigAsync };
};
